<scoot-header></scoot-header>
<!-- Handles Navigation when managing scootaverses -->
<page-header
  [roomName]="roomName"
  [social]="social"
  [scootaverseName]="scootaverseName"
  [scootaverseId]="scootaverseId"
></page-header>

<div [ngStyle]="{ height: '100%' }">
  <mat-drawer-container class="scootaverse-container" [ngClass]="{ 'page-content': showSideMenu }">
    @if (showSideMenu) {
      <mat-drawer class="scootaverse-sidenav new-nav" mode="side" [opened]="isDrawerOpen" [disableClose]="true">
        @if (roomName) {
          <span class="room-name-sidemenu">{{ roomName }} - Room</span>
        } @else if (scootaverseName && !editingName) {
          <span class="room-name-sidemenu" (dblclick)="startEditing(scootaverseName)">
            {{ scootaverseName }} - Scootaverse
          </span>
        } @else if (scootaverseName && editingName) {
          <input
            [(ngModel)]="newScootaverseName"
            [readonly]="!editingName"
            type="text"
            class="edit-scootaverse-name"
            maxLength="256"
            (blur)="editScootaverseName()"
          />
        }
        <div class="side-menu">
          <div class="nav flex flex-column">
            @for (navItem of navRoutes; track navItem.url) {
              @if (navItem.isSideMenu && navItem.isVisible && flagIsAvailable(navItem)) {
                <button
                  class="nav-item"
                  [ngClass]="{ active: checkURLActive(navItem) }"
                  (click)="clickSideMenuRoute(navItem)"
                >
                  @if (navItem.icon) {
                    <mat-icon>
                      {{ navItem.icon }}
                    </mat-icon>
                  } @else if (navItem.svgIcon) {
                    <mat-icon class="svg-mat-icon" [svgIcon]="navItem.svgIcon"> </mat-icon>
                  }
                  <span class="nav-button">
                    {{ navItem.name }}
                  </span>
                </button>
              }
              @if (navItem.subRoutes) {
                @for (subItem of navItem.subRoutes; track subItem.url) {
                  @if (showSideMenuOption(subItem)) {
                    <button
                      class="sub-nav-item"
                      [ngClass]="{ active: checkURLActive(subItem) }"
                      (click)="clickSideMenuRoute(subItem)"
                    >
                      @if (subItem.icon) {
                        <mat-icon>
                          {{ subItem.icon }}
                        </mat-icon>
                      }
                      <span class="nav-button">
                        {{ subItem.name }}
                      </span>
                    </button>
                  }
                }
              }
            }
          </div>
        </div>
      </mat-drawer>
    }

    <!-- Drawer Content -->
    <mat-drawer-content class="scootaverse-page-content content">
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
